import { TestItem } from 'store/src/lib/tests/entity';
import { TestFormValues, ALLOWED_RATINGS } from '@app.raytd.com/common/types/test-form';
import { convertScoreToRating } from '@/app/features/reports/ratingHelpers';

const convertInspectionToFormValues = (
  tests: TestItem
): Partial<TestFormValues> => {
  // Normalize various possible result representations to canonical tokens
  function normalizeResult(value: unknown): string | undefined {
    if (value === null || value === undefined) return undefined;

    // Numeric score -> token
    if (typeof value === 'number') return convertScoreToRating(value);

    const raw = String(value).trim();
    if (!raw) return undefined;

    // Try parse numeric string
    const asNum = Number(raw);
    if (!Number.isNaN(asNum) && asNum > 0) return convertScoreToRating(asNum);

    // Tokenize labels like "Very Good" => "very_good"
    const token = raw.toLowerCase().replace(/\s+/g, '_');
    const allowed = new Set<string>(ALLOWED_RATINGS);
    return allowed.has(token) ? token : undefined;
  }

  const formattedData: Partial<TestFormValues> = {
    formId: tests.formId,
    assessmentId: tests.assessmentId,
    assetId: tests.assetId,
    test_specification_id: tests.testSpecificationId,
    building_id: tests.buildingId,
    level_id: tests.levelId,
    area_id: tests.areaId,
    element: tests.element_classification_id,
    element_id: tests.element_id ?? undefined,
    element_name: tests.element_name ?? undefined,
    observations: tests.observations,
    recommendations: tests.recommendations,
    result: normalizeResult(tests.result) as any,
    status: tests.status.toLowerCase() as any,
    images: tests.images,
    custom: tests.custom,
  };

  return formattedData;
};

export default convertInspectionToFormValues;
